import http from '../../../../../libs/http'

export default ({ id }) => {
  const url = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/table-amortization/download-template-xls/${id}`
  const res = http.getUri({ url })
  window.open(res, '_blank')
}
